// SceneTransitionHelper.js - 场景切换（sleep/wake 优先）
import DebugHelper from './DebugHelper.js';

/**
 * 切换到目标世界场景
 * @param {Phaser.Scene} currentScene
 * @param {string} targetSceneKey
 * @param {Object} data - 传给目标场景的 init/wake 数据
 */
export function transitionToWorldScene(currentScene, targetSceneKey, data = {}) {
    const sm = currentScene.scene;
    const target = sm.get(targetSceneKey);

    if (target && target.scene.isSleeping()) {
        DebugHelper.log(`SceneTransition: wake ${targetSceneKey}`);
        sm.sleep(sm.key);
        sm.wake(targetSceneKey, data);
        return;
    }

    if (target && target.scene.isActive() && sm.key !== targetSceneKey) {
        DebugHelper.log(`SceneTransition: restart active ${targetSceneKey}`);
        sm.sleep(sm.key);
        sm.start(targetSceneKey, data);
        return;
    }

    DebugHelper.log(`SceneTransition: start ${targetSceneKey}`);
    if (sm.key !== targetSceneKey) {
        sm.sleep(sm.key);
    }
    sm.start(targetSceneKey, data);
}
